
export default function usePersistedState (appContext) {
  const persistCheckoutState = (state) => {
    if (process.client) {
      const stateToStore = {
        subscription: state?.subscription,
        numberInfo: state?.numberInfo?.value
      };
      appContext.$storage.setLocalStorage('checkoutState', stateToStore)
    }
  }
  const getPersistedCheckoutState = () => {
    if (process.client) {
      return appContext.$storage.getLocalStorage('checkoutState');
    }
  }
  const removePersistedState = () => {
    appContext.$storage.removeLocalStorage('checkoutState');
  }
  return {
    removePersistedState,
    persistCheckoutState,
    getPersistedCheckoutState
  }
}
